import {Entity, Toast} from '@chaysehartsuff/active-html';
import BlogItemEntity from './BlogItemEntity.js';
import BlogToolBar from './BlogToolBar.js';
import {ContentOverlay} from '@chaysehartsuff/active-html';
import {QuickActionMenu} from '@chaysehartsuff/active-html';
import {Element} from '@chaysehartsuff/active-html';
import {Select} from '@chaysehartsuff/active-html';
import {Button} from '@chaysehartsuff/active-html';
import {Color} from '@chaysehartsuff/active-html';
import {Checkbox} from '@chaysehartsuff/active-html';
import QuillTextbox from './items/QuillTextbox.js';
import ImageItem from './items/ImageItem.js';
import BlogHeader from './items/BlogHeader.js';
import {Dao} from '@chaysehartsuff/active-html';
import Blog from '../../models/Blog.js';
import PublishedBlog from '../../models/PublishedBlog.js';
import UserImage from '../../models/UserImage.js';
import User from '../../models/User.js';
import PhotoManager from '../photo/PhotoManager.js';
/**
 * Interactable blog editor
 */
export default class BlogEntity extends Entity {
    /**
     * 
     * @param {Map<string, BlogItemEntity>} entities
     */
    entities;
    /**
     * @type {User} user
     */
    user;
    /**
     * Meta data for blog header
     * @type {object}
     */
    meta_data = {
        title: 'Untitled Blog',
        description: null,
        read_mins: 1,
        author_name: "Author Name",
        publish_date: new Date().toISOString(),
        tags: ['Finance', 'Investing'],
        header_image: null,
    };
    /**
     * @type {BlogToolBar} blogToolBar
     */
    blogToolBar;
    /**
     * @type {boolean}
     */
    is_pinned;

    imageKeyWordInput;
    headerThumbnail;
    categories = [];

    blogItemList = [
        {key: 'quillItem', label: "Text/Image", class: QuillTextbox},
        {key: 'headerItem', label: "Header", class: BlogHeader, in_list: false},
    ]

    /**
     * Flag to track if the current state of the blog is saved or has unsaved changes.
     * @type {boolean}
     */
    saved;

    /**
     * 
     * @param {HTMLElement} blogElement 
     */
    constructor(blogElement = null, blogId = null) {
        super();
        this.entities = new Map();
        this.user = new User();
        this.blog = new Blog();

        this.is_pinned = false;

        // Setup blog tools and listeners
        this.blogToolBar = new BlogToolBar();
        this.blogToolBar.addListener(BlogToolBar.newItemEvent, this.onNewItem.bind(this));
        this.blogToolBar.addListener(BlogToolBar.editBlogEvent, this.onEditBlog.bind(this));
        this.blogToolBar.addListener(BlogToolBar.quickActionEvent, this.onQuickAction.bind(this));
        this.addContent(this.blogToolBar);

        // setup sticky Preview/Publish button at bottom right of the editor
        this.actionText = new Element().addContent('Save').addClass('min-w-[5rem] text-center');
        this.statusText = new Element().addContent('*Unsaved');
        this.saveButton = new Element()
        .addContent(
            new Element().addContent(this.actionText).addClass('text-md px-14 py-2 hover:bg-blue-800 transition-colors')
        )
        .addContent(
            new Element()
                .addContent(this.statusText)
                .addClass('text-center text-xs px-2 py-1 italic text-white bg-gray-700 ')
        )
        .addClass(' cursor-pointer fixed bottom-0 right-0 hover:bg-gray-700')
        .setStyle('background-color', '#175ba8')
        .setStyle('color', 'white')
        .onEvent('click', this.onSaveBlog.bind(this))
        ;
        this.addContent(this.saveButton);

        // setup sticky Unpublish button (that is grayed out when no published version exists) to the left of the save button
        this.unPublishText = new Element().addContent('Unpublish').addClass('min-w-[5rem] text-center text-white-700 opacity-50');
        this.publishStatusText = new Element().addContent('Not published').addClass('text-center text-xs px-2 py-1 italic  bg-gray-700');
        this.unPublishInner = new Element().addContent(this.unPublishText).addClass('text-md px-14 py-2 transition-colors');
        this.unPublishButton = new Element()
        .addContent(this.unPublishInner)
        .addContent(this.publishStatusText)
        .addClass(' fixed bottom-25 right-0')
        .setStyle('background-color', '#732cb6')
        .setStyle('color', 'white')
        .onEvent('click', this.onUnPublishBlog.bind(this))
        ;
        this.addContent(this.unPublishButton);

        // add initial header
        if (this.user.name) {
            this.meta_data.author_name = this.user.name;
        }
        if (!this.header) {
            this.header = new BlogHeader(this.meta_data);
            this.wireBlogItem(this.header);
            this.addEntity(this.header);
        }

        this.markAsUnsaved();
        if(blogId){
            this.blog.id = blogId;
            this.blog.getSync();
            Dao.modelRequest('getPublishedBlog', this.blog, (response) => {
                const publishedBlog = response.published_blog;

                let niceDate = publishedBlog.publish_date 
                ? publishedBlog.publish_date.split('-').slice(1).concat(publishedBlog.publish_date.split('-')[0]).join('/')
                : 'No publish date';
                
                if(publishedBlog && publishedBlog.is_published){
                    this.markAsPublished(`Published on <strong>${niceDate}</strong>`);
                } else {
                    this.markAsUnPublished();
                }
                this.published_blog = new PublishedBlog();
                this.published_blog.id = publishedBlog.id;
                this.published_blog.getSync();
            });
            this.importJson(this.blog.meta_data);
        } else {
            let defaultItem = new QuillTextbox();
            this.wireBlogItem(defaultItem);
            this.addEntity(
                defaultItem
            );
        }
        Dao.modelRequest('getCategories', this.blog, (response) => {
            this.categories = response.categories || [];
        });
        // Initialize if blogElement is provided
        if(blogElement instanceof HTMLElement) {
            blogElement.innerHTML = this.compile();
            this.bindEvents();
        }
        // generate header iamge
        if(!this.meta_data.header_image){
            Dao.modelRequest('getPexelImg', this.blog, (response) => {
                console.log('Profile image response', response.pexel_img.src.landscape);
                this.updateHeaderImage(response.pexel_img.src.landscape);
            });
        }
    }

    updateHeaderImage(imagePath) {
        if (!imagePath) {
            return;
        }

        this.meta_data.header_image = imagePath;
        if (this.header) {
            this.header.updateMetaDataUI(this.meta_data);
        }
        if (this.headerThumbnail) {
            this.headerThumbnail.setAttribute('src', imagePath);
        }
        this.markAsUnsaved();
    }

    /**
     * Adds entity to blog for serialization
     * @param {BlogItemEntity} entity 
     */
    addEntity(entity) {
        if (entity instanceof BlogItemEntity) {
            entity.addClass('relative group');
            this.entities.set(entity.getId(), entity);
            this.markAsUnsaved();
            return this.addContent(entity);
        } else {
            throw new Error('Must be of type Entity');
        }
    }

    removeEntity(key) {
        if (this.entities.has(key)) {
            this.entities.delete(key);
            this.removeContent(key);
        } else {
            console.warn(`Entity with key '${key}' not found to remove`);
        }
    }

    exportObject() {
        const exportedEntities = {};
        for (const [key, entity] of this.entities) {
            exportedEntities[key] = entity.exportObject();
        }

        return {
            ...super.exportObject(),
            entities: exportedEntities,
            meta_data: this.meta_data
        }
    }

    importObject(obj) {
        if (!obj || typeof obj !== 'object') {
            throw new Error('Import data must be an object.');
        }

        // 1) Restore meta data first so dependent entities (like BlogHeader) can render correctly.
        if (obj.meta_data && typeof obj.meta_data === 'object' && !Array.isArray(obj.meta_data)) {
            this.meta_data = {
                ...this.meta_data,
                ...obj.meta_data,
            };
        }

        // Reset current entities before rebuilding from serialized data.
        for (const key of Array.from(this.entities.keys())) {
            this.removeEntity(key);
        }
        this.header = null;

        const entityClassMap = new Map(
            this.blogItemList
                .filter(item => item?.class && typeof item.class === 'function')
                .map(item => [item.class.name, item.class])
        );
        entityClassMap.set(BlogItemEntity.name, BlogItemEntity);

        if (obj.entities && typeof obj.entities === 'object' && !Array.isArray(obj.entities)) {
            for (const [key, entityObj] of Object.entries(obj.entities)) {
                if (!entityObj || typeof entityObj !== 'object') {
                    console.warn(`Skipping invalid entity payload for key '${key}'.`);
                    continue;
                }

                const EntityClass = entityClassMap.get(entityObj.class);
                if (!EntityClass) {
                    console.warn(`Unknown entity class '${entityObj.class}' for key '${key}'. Skipping.`);
                    continue;
                }

                let entity;
                try {
                    entity = new EntityClass();
                    entity.importObject(entityObj);
                } catch (error) {
                    console.warn(`Failed to import entity '${key}' of class '${entityObj.class}'.`, error);
                    continue;
                }

                if (typeof key === 'string') {
                    entity.setId(key);
                }

                this.wireBlogItem(entity);

                if (entity instanceof BlogHeader) {
                    entity.updateMetaDataUI(this.meta_data);
                    this.header = entity;
                }

                this.addEntity(entity);
            }
        } else {
            console.warn('No entities object found in import data or it is not an object.');
        }

        // Guarantee a header exists for editing metadata even if serialized data is missing one.
        if (!this.header) {
            this.header = new BlogHeader(this.meta_data);
            this.wireBlogItem(this.header);
            this.addEntity(this.header);
        }

        this.markAsSaved();
        return this;
    }

    wireBlogItem(item) {
        if (!(item instanceof BlogItemEntity)) {
            return;
        }

        item.addListener(BlogItemEntity.onDeleteEvent, this.onItemDelete.bind(this));
        item.addListener(BlogItemEntity.onChangeEvent, () => { this.markAsUnsaved(); });
    }

    onNewItem(e) {
        this.blogToolBar.removeContent('blogNewItem');
        let actionMenu = new QuickActionMenu(this.blogToolBar).addClass('top-10');
        for (const item of this.blogItemList) {
            if(item.in_list === false){
                continue;
            }
            actionMenu.addAction(item.key, item.label, (value) => {
                for (const item of this.blogItemList) {
                    if (item.key === value) {
                        let newItem = new item.class();
                        this.wireBlogItem(newItem);
                        if (newItem instanceof BlogItemEntity) {
                            this.addEntity(newItem);
                        } else {
                            console.warn('Invalid class for new item');
                        }
                        break;
                    }
                }
            });
        }
        actionMenu.addListener(QuickActionMenu.onCloseEvent, () => {
             this.blogToolBar.removeContent('blogNewItem'); 
            })
        this.blogToolBar.addContent(actionMenu, 'blogNewItem');

    }
    onItemDelete(uuid, force_prompt = true){
        if (force_prompt) {
            let areYouSure = new ContentOverlay(
                new Element()
                .addClass('bg-white p-10')
                .addContent(new Element().addContent('Are you sure you want to delete this item?').addClass('my-5'))
                .addContent(
                    new Element().addClass('flex justify-around items-center')
                    .addContent(
                        new Button('Delete', Color.RED)
                        .onEvent('click', () => {
                            if (uuid) {
                                this.removeEntity(uuid);
                                this.markAsUnsaved();
                            } else {
                                console.error('data-uuid attribute missing', e);
                            }
                            this.removeContent(areYouSure);
                        })
                    )
                    .addContent(
                        new Button('Cancel', Color.GRAY)
                        .onEvent('click', () => {
                            this.removeContent(areYouSure);
                        })
                    )
                )
            ).addListener(ContentOverlay.onCloseEvent, () => { this.removeContent(areYouSure);  });
            this.addContent(areYouSure);
        } else {
            if (uuid) {
                this.removeEntity(uuid);
            } else {
                console.error('data-uuid attribute missing');
            }
        }
    }
    async onEditBlog(e){
        const fieldClass = 'w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-800 shadow-sm transition focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200';
        const labelClass = 'mb-1 block text-sm font-semibold text-gray-700';
        const secondaryButtonClass = 'inline-flex items-center justify-center rounded-lg border border-gray-300 bg-gray-50 px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm transition hover:bg-gray-100';

        const getDateInputValue = (dateValue) => {
            const date = new Date(dateValue || new Date());
            if (Number.isNaN(date.getTime())) {
                return new Date().toISOString().slice(0, 10);
            }
            return date.toISOString().slice(0, 10);
        };

        if (!Array.isArray(this.meta_data.tags)) {
            this.meta_data.tags = [];
        }

        const tagInput = new Element('input')
            .setAttribute('type', 'text')
            .setAttribute('placeholder', 'Add a tag and press Enter')
            .addClass(fieldClass)
            .onEvent('keydown', (event) => {
                if (event.key !== 'Enter') {
                    return;
                }

                event.preventDefault();
                const value = (event.target.value || '').trim();
                if (!value) {
                    return;
                }

                const hasTag = this.meta_data.tags.some((tag) => tag.toLowerCase() === value.toLowerCase());
                if (!hasTag) {
                    this.meta_data.tags.push(value);
                    renderTagList();
                }

                event.target.value = '';
            });

        const tagList = new Element().addClass('mt-3 flex flex-wrap gap-2');

        const renderTagList = () => {
            tagList.clearContent();

            if (this.meta_data.tags.length === 0) {
                tagList.addContent(new Element().addClass('text-xs text-gray-500').addContent('No tags yet.'));
                return;
            }

            this.meta_data.tags.forEach((tag, index) => {
                const deleteTagButton = new Element('button')
                    .setAttribute('type', 'button')
                    .addClass('ml-2 text-blue-700 hover:text-blue-900')
                    .addContent('x')
                    .onEvent('click', () => {
                        this.meta_data.tags.splice(index, 1);
                        renderTagList();
                    });

                tagList.addContent(
                    new Element('span')
                        .addClass('inline-flex items-center rounded-full bg-blue-100 px-3 py-1 text-xs font-semibold text-blue-800')
                        .addContent(new Element().addContent(tag))
                        .addContent(deleteTagButton)
                );
            });
        };

        renderTagList();

        this.isPinnedText = new Element('span').addContent('Pin Blog').addClass('opacity-50').setAttribute('title', 'Blog must be published to pin');
        this.isPinnedCheckbox = new Checkbox()
            .addClass('h-4 w-4 rounded border-gray-300 text-blue-600 pointer-events-none opacity-60');
        Dao.modelRequest('getPublishedBlog', this.blog, (response) => {
            console.log('Published blog response', response);
            if(response.published_blog){
                // remove pointer-events-none and opacity-60 classes to make checkbox interactive on both checkbox and ttext
                this.isPinnedText.removeClass('opacity-50').removeAttribute('title');
                this.isPinnedCheckbox.removeClass('pointer-events-none').removeClass('opacity-60');
                if(response.published_blog.is_pinned){
                    this.is_pinned = true;
                    this.isPinnedCheckbox.setChecked(true);
                }
            }
        });

        this.imageKeyWordInput = new Element('input')
            .setAttribute('type', 'text')
            .setAttribute('placeholder', 'Optional keywords')
            .addClass(fieldClass);

        this.headerThumbnail = new Element('img')
            .setAttribute('src', this.meta_data.header_image || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==')
            .addClass('h-10 w-10 cursor-pointer rounded-md border border-gray-200 bg-gray-100 object-cover transition duration-150 hover:brightness-75 hover:shadow-md hover:ring-2 hover:ring-blue-300')
            .onEvent('click', () => {
                let photoManager = new PhotoManager(true, false, 110);
                photoManager.addListener(PhotoManager.onUserSelectionEvent, (uuid) => {
                    console.log('Selected image from photo manager', uuid);
                    this.updateHeaderImage('/image/' + uuid);
                    this.removeContent(photoManager.getId());
                });
                this.addContent(photoManager, 'chooseHeaderImage');
            });

        const categoryList = new Element().addClass('mt-2 space-y-2');
        if (Array.isArray(this.categories)) {
            this.categories.forEach((category) => {
                const checkbox = new Element('input')
                    .setAttribute('type', 'checkbox')
                    .setAttribute('value', category.id)
                    .setId(`category-checkbox-${category.id}`)
                    .addClass('h-4 w-4 rounded border-gray-300 text-blue-600');

                if (category.selected) {
                    checkbox.setAttribute('checked', 'checked');
                }

                categoryList.addContent(
                    new Element('label')
                        .addClass('flex items-center gap-2 text-sm text-gray-700')
                        .addContent(checkbox)
                        .addContent(category.name)
                );
            });
        }

        this.categorySelect = new Element()
            .addClass('mb-5 max-h-20 overflow-y-auto pr-1')
            .addContent(
                new Element()
                    .addClass(`${labelClass} sticky top-0 z-10 bg-white py-1`)
                    .addContent('Categories')
                    .setAttribute('title', 'Blog must be created first')
                )
            .addContent(categoryList);

        this.addContent(
            new ContentOverlay(
                new Element().addClass('w-full max-w-2xl rounded-xl bg-white p-6 shadow-2xl md:p-8')
                .addContent(new Element().addClass('mb-6 border-b border-gray-100 pb-4 text-2xl font-bold text-gray-900').addContent('Edit Blog Details'))
                .addContent(
                    new Element().addClass('mb-5')
                    .addContent(new Element().addClass(labelClass).addContent('Title'))
                    .addContent(
                        new Element('input')
                            .setAttribute('type', 'text')
                            .setAttribute('value', this.meta_data.title)
                            .addClass(fieldClass)
                            .onEvent('input', (event) => { this.meta_data.title = event.target.value; })
                    )
                )
                .addContent(
                    new Element().addClass('mb-5')
                    .addContent(new Element().addClass(labelClass).addContent('Description'))
                    .addContent(
                        new Element('textarea')
                            .setProperty('value', this.meta_data.description || '')
                            .setContent(this.meta_data.description || '')
                            .setAttribute('placeholder', 'Enter a brief description of the blog...')
                            .setAttribute('rows', 4)
                            .addClass(fieldClass)
                            .onEvent('input', (event) => { this.meta_data.description = event.target.value; })
                    )
                )
                .addContent(
                    new Element().addClass('mb-5')
                    .addContent(new Element().addClass(labelClass).addContent('Header Image'))
                    .addContent(
                        new Element().addClass('flex flex-col gap-3')
                        .addContent(
                            new Element().addClass('flex flex-col gap-3 md:flex-row md:items-center')
                            .addContent(
                                this.headerThumbnail
                            )
                            .addContent(
                                new Element('button')
                                    .setAttribute('type', 'button')
                                    .addClass(`${secondaryButtonClass} md:flex-shrink-0`)
                                    .addContent('New Image')
                                    .onEvent('click', () => {
                                        let query = this.imageKeyWordInput.getValue().trim();
                                        let params = {};
                                        if (query) {
                                            params.query = query;
                                        }
                                        Dao.modelRequest('getPexelImg', this.blog, (response) => {
                                            this.updateHeaderImage(response.pexel_img.src.landscape);
                                        }, params);
                                    })
                            )
                            .addContent(
                                this.imageKeyWordInput
                            )
                        )
                    )
                )
                .addContent(
                    new Element().addClass('mb-5 grid grid-cols-1 gap-4 md:grid-cols-2')
                    .addContent(
                        new Element()
                            .addContent(new Element().addClass(labelClass).addContent('Read Time (mins)'))
                            .addContent(
                                new Element('input')
                                    .setAttribute('type', 'number')
                                    .setAttribute('min', 1)
                                    .setAttribute('value', this.meta_data.read_mins)
                                    .addClass(fieldClass)
                                    .onEvent('input', (event) => { this.meta_data.read_mins = parseInt(event.target.value, 10) || 1; })
                            )
                    )
                    .addContent(
                        new Element()
                            .addContent(new Element().addClass(labelClass).addContent('Publish Date'))
                            .addContent(
                                new Element('input')
                                    .setAttribute('type', 'date')
                                    .setAttribute('value', getDateInputValue(this.meta_data.publish_date))
                                    .addClass(fieldClass)
                                    .onEvent('input', (event) => {
                                        const selectedDate = event.target.value;
                                        this.meta_data.publish_date = selectedDate ? `${selectedDate}T00:00:00` : new Date().toISOString();
                                    })
                            )
                    )
                )
                .addContent(
                    new Element().addClass('mb-5 grid grid-cols-1 gap-4 md:grid-cols-2')
                    .addContent(
                        new Element()
                        .addContent(new Element().addClass(labelClass).addContent(this.isPinnedText))
                        .addContent(this.isPinnedCheckbox)
                    )
                    .addContent(
                        this.categorySelect
                    )
                )
                .addContent(
                    new Element().addClass('mb-6')
                    .addContent(new Element().addClass(labelClass).addContent('Tags'))
                    .addContent(tagInput)
                    .addContent(new Element().addClass('mt-2 text-xs text-gray-500').addContent('Press Enter to add a tag.'))
                    .addContent(tagList)
                )
                .addContent(
                    new Element().addClass('flex justify-end gap-3 border-t border-gray-100 pt-4')
                    .addContent(
                        new Button('Save', Color.BLUE)
                        .onEvent('click', () => {
                            this.is_pinned = this.isPinnedCheckbox.checked();
                            this.header.updateMetaDataUI(this.meta_data);
                            this.markAsUnsaved();
                            // Update category selections
                            for (let i = 0; i < this.categories.length; i++) {
                                const category = this.categories[i];
                                const checkbox = document.getElementById(`category-checkbox-${category.id}`);
                                const isChecked = checkbox && checkbox.checked;
                                this.categories[i].selected = isChecked;
                            }
                            this.removeContent('editBlogMeta');
                        })
                    )
                    .addContent(
                        new Button('Cancel', Color.GRAY)
                        .onEvent('click', () => {
                            this.removeContent('editBlogMeta');
                        })
                    )
                )
            ), 'editBlogMeta'
        )
    }

    onSaveBlog(e){
        
        this.blog.title = this.meta_data.title;
        this.blog.description = this.meta_data.description;
        this.blog.meta_data = this.exportJson();
        if(this.blog.id){
            this.blog.updateSync();

            // run pin blog action if pinned blog is true
            if (this.is_pinned != undefined && this.published_blog && this.is_pinned != null) {
                this.published_blog.is_pinned = this.is_pinned;
                this.published_blog.update();
            }
            // create preview if blog is up to date
            if (this.saved) {
                let publised_blog = new PublishedBlog();
                publised_blog.blog_id = this.blog.id;
                publised_blog.title = this.blog.title;
                publised_blog.description = this.blog.description;
                publised_blog.content = this.compilePreview();
                publised_blog.publish_date = new Date(this.meta_data.publish_date).toISOString().slice(0, 19).replace('T', ' ');
                publised_blog.is_published = false;
                publised_blog.create({}, ()=>{}, false);
                window.open(`/blog/preview/${publised_blog.id}`, '_blank');
                console.log('Blog published successfully', publised_blog);
            }
        } else {
            this.blog.createSync();
        }
        if (this.blog.id) {
            // update category relationships
            const categoryIds = this.categories
                .filter((cat) => cat.selected)
                .map((cat) => Number(cat.id))
                .filter((id) => Number.isFinite(id));

            const categoryIdsCsv = categoryIds.join(',');
            Dao.modelRequest('setCategories', this.blog, function (response) {
            }, { category_ids: categoryIdsCsv });
        }
        this.markAsSaved();
    }

    onUnPublishBlog(e) {
        this.removeContent('unpublishConfirm');
        let areYouSure = new ContentOverlay(
            new Element()
                .addClass('bg-white p-10')
                .addContent(new Element().addContent('Are you sure you want to unpublish this blog?').addClass('my-5'))
                .addContent(
                    new Element().addClass('flex justify-around items-center')
                        .addContent(
                            new Button('Unpublish', Color.RED)
                                .onEvent('click', () => {
                                    Dao.modelRequest('unpublishBlog', this.blog, (response) => {
                                        this.markAsUnPublished();
                                        this.removeContent('unpublishConfirm');
                                        new Toast('Unpublished blog.').success();
                                    });
                                })
                        )
                        .addContent(
                            new Button('Cancel', Color.GRAY)
                                .onEvent('click', () => {
                                    this.removeContent('unpublishConfirm');
                                })
                        )
                )
        ).addListener(ContentOverlay.onCloseEvent, () => { this.removeContent('unpublishConfirm'); });
        this.addContent(areYouSure, 'unpublishConfirm');
    }

    onQuickAction(e) {
        this.blogToolBar.removeContent('blogQuickAction');
        let actionMenu = new QuickActionMenu(this.blogToolBar).addClass('top-10 right-0');

        actionMenu.addAction('photo-manager', 'Photo Manager', () => {
            let photoManager = new PhotoManager(false,true);
            photoManager.addListener(PhotoManager.onCancelEvent, (manager) => {
                this.removeContent(photoManager.getId());
            });
            this.addContent(photoManager);
        });
        actionMenu.addAction('saveNExit', 'Save and Exit', () => {
            if(!this.saved) {
                this.onSaveBlog();
            }
            window.location.href = '/blog/list';
        });
        actionMenu.addAction('exitWOSave', 'Exit', () => {
            if(!this.saved) {
                let areYouSure = new ContentOverlay(
                    new Element()
                        .addClass('bg-white p-10')
                        .addContent(new Element().addContent('You have unsaved changes. Are you sure you want to exit?').addClass('my-5'))
                        .addContent(
                            new Element().addClass('flex justify-around items-center')
                                .addContent(
                                    new Button('Exit without Saving', Color.RED)
                                        .onEvent('click', () => {
                                            this.removeContent(areYouSure);
                                            window.location.href = '/blog/list';
                                        })
                                )
                                .addContent(
                                    new Button('Cancel', Color.GRAY)
                                        .onEvent('click', () => {
                                            this.removeContent(areYouSure);
                                        })
                                )
                        )
                ).addListener(ContentOverlay.onCloseEvent, () => { this.removeContent(areYouSure); });
                this.addContent(areYouSure);
                return;
            }
            window.location.href = '/blog/list';
        });
        actionMenu.addListener(QuickActionMenu.onCloseEvent, () => { this.blogToolBar.removeContent('blogQuickAction');  })
        this.blogToolBar.addContent(actionMenu, 'blogQuickAction');
    }

    markAsSaved() {
        this.saved = true;
        this.actionText.setContent('Preview');
        this.statusText.setContent('Saved');
    }

    markAsUnsaved() {
        this.saved = false;
        if(this.blog.id){
            this.actionText.setContent('Save');
            this.statusText.setContent('*Unsaved');
        } else {
            this.actionText.setContent('Create');
            this.statusText.setContent('*Unsaved');
        }
    }
    // TODO: REMOVE calss is not working
    markAsPublished(status_text = 'Published') {
        this.unPublishText.removeClass('opacity-50').addClass('cursor-pointer');
        this.unPublishInner.addClass('hover:bg-purple-800');
        this.publishStatusText.setContent(status_text); 
        this.unPublishButton.onEvent('click', this.onUnPublishBlog.bind(this));
    }

    markAsUnPublished() {
        this.unPublishText.addClass('opacity-50').removeClass('cursor-pointer');
        this.unPublishInner.removeClass('hover:bg-purple-800');
        this.publishStatusText.setContent('Not published');
        this.unPublishButton.removeEvent('click', this.onUnPublishBlog.bind(this));
    }

    compilePreview(){
        let content = '';
        for (const [key, entity] of this.entities) {
            content += entity.compilePreview();
        }
        return content.replace(/&nbsp;/g, ' ');
    }
}